import { isLineItemEditable, hasActiveArtworkServices } from '@printdeal/business-logic';

import useProductDetailPageExists from '../../../../../../hooks/useProductDetailPageExists';
import Order, { SanitizedLineItem } from '../../../../../../types/order/Order';
import { Environment } from '../../../../../../helpers/env';

const ReasonsDisabled = {
  UNSUITABLE_PRODUCT: 'Unsuitable product',
  MISSING_PRODUCT_DETAIL_PAGE: 'Missing product detail page',
  HAS_ACTIVE_ART_SERVICE: 'Has an active art service',
};

const useEditLineItem = (lineItem: SanitizedLineItem, order: Order) => {
  const {
    productKey,
    mcpSku,
    contentfulPageId,
  } = lineItem.custom.fields;

  const productDetailPageExists = useProductDetailPageExists(contentfulPageId);

  if (!isLineItemEditable(Environment, lineItem, order.lineItems)
    || !productKey
    || !mcpSku
    || !contentfulPageId
    || Boolean(order.fileChangeService?.quantity)
    || Boolean(order.fileDesignService?.quantity)) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.UNSUITABLE_PRODUCT,
    };
  }

  if (!productDetailPageExists) {
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.MISSING_PRODUCT_DETAIL_PAGE,
    };
  }

  if (hasActiveArtworkServices(lineItem.id, order, Environment)) {
    // The customer has requested an art service and thus should not be able to edit the lineItem because...
    // ... that would mess up the artwork we created.
    return {
      enabled: false,
      reasonDisabled: ReasonsDisabled.HAS_ACTIVE_ART_SERVICE,
    };
  }

  return {
    enabled: true,
  };
};

export default useEditLineItem;
